import axios from "axios";

export const localeStore = defineStore("locale", {
  state: () => ({
    locale: "",
  }),
  actions: {
    setLocale(payload: string) {
      this.locale = payload;
    },
    getLocale() {
      axios
        .get("/api/get-locale")
        .then((response) => {
          this.locale = response.data.locale;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
  },
  persist: {
    key: "locale",
    storage: piniaPluginPersistedstate.localStorage(),
  },
});
